const COLORS = {
  PRIMARY: {
    main: '#FF6F00', // Orange color for primary
    light: '#FF9E3D', // Light orange color
    dark: '#C43E00', // Darker orange color
    contrastText: '#ffffff', // White text on primary
  },

  SECONDARY: {
    main: '#424242', // Dark grey color for secondary
    light: '#6D6D6D', // Lighter grey
    dark: '#1B1B1B', // Darker grey
    contrastText: '#ffffff', // White text on secondary
  },

  ERROR: {
    main: '#D32F2F', // Red color for error
    light: '#FF6659', // Lighter red
    dark: '#9A0007', // Darker red
    contrastText: '#ffffff', // White text on error
  },

  WARNING: {
    main: '#FF9800', // Orange-yellow color for warning
    light: '#FFB74D', // Lighter orange-yellow
    dark: '#F57C00', // Darker orange-yellow
    contrastText: '#ffffff', // White text on warning
  },

  INFO: {
    main: '#0288D1', // Blue color for info
    light: '#33B5E5', // Lighter blue
    dark: '#01579B', // Darker blue
    contrastText: '#ffffff', // White text on info
  },

  SUCCESS: {
    main: '#388E3C', // Green color for success
    light: '#66BB6A', // Lighter green
    dark: '#00600F', // Darker green
    contrastText: '#ffffff', // White text on success
  },
};

export default COLORS;
